import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/bills/invoices` on its own — somebody trimming an invoice's address back a level.
 *
 * Without this it would match `/bills/$ref` and say "invoices is not a record reference". The list
 * is the Tenancy invoices tab on Bills, so it goes there.
 */
export const Route = createFileRoute('/bills/invoices/')({
  beforeLoad: () => {
    throw redirect({ to: '/bills', search: { tab: 'tenancy' }, replace: true });
  },
});
